<template>
	<div>metadata</div>
</template>

<script>

export default {
	name: 'pagemetadata'
}
</script>
